import { InputAdornment } from "@mui/material";
import React from "react";
import { useState } from "react";
import { Form } from "../../../layout";
import { Button, Input } from "../../../controls";
import { useNavigate } from "react-router-dom";
import { action, API, controller } from "api";

const OpenReturn = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");

  const handleInpChg = (e) => {
    setInvoiceNo(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    invoiceNo &&
      API(controller.Sell + action.ValidateInvoiceId).getById(
        invoiceNo,
        (res) => {
          res?.result
            ? navigate(`/sell_return_form/${invoiceNo}`)
            : setError("Invalid Invoice Number");
        }
      );
  };

  return (
    <>
      <Form onSubmit={handleSubmit} noValidate>
        <Input
          error={error}
          sx={{
            "& .MuiInputBase-root": {
              maxWidth: "220px",
              paddingRight: "1px",
              "& .MuiInputBase-input": {
                padding: "6px 10px",
                fontSize: "14px",
              },
            },
          }}
          placeholder="Return Invoice No."
          value={invoiceNo}
          InputProps={{
            maxLength: 50,
            endAdornment: (
              <InputAdornment position="end">
                <Button
                  size="small"
                  type="submit"
                  sx={{
                    minWidth: "45px",
                    padding: "2px 6px",
                    marginRight: "2px",
                    borderRadius: "9px",
                  }}
                >
                  OPEN
                </Button>
              </InputAdornment>
            ),
          }}
          onChange={handleInpChg}
          size="small"
        />
      </Form>
    </>
  );
};

export default OpenReturn;
